import { useEffect, useState } from 'react';

export function formatRegistrarNumber(value, { precision = 1, signed = false } = {}) {
  const magnitude = Math.abs(value).toFixed(precision);
  if (value < 0) return `−${magnitude}`;
  if (signed) return `+${magnitude}`;
  return Number(value).toFixed(precision);
}

export default function RegistrarNumber({ value, active, reduced, precision = 1, signed = false, runKey = 0 }) {
  const [shown, setShown] = useState(reduced ? value : 0);

  useEffect(() => {
    if (reduced) {
      setShown(value);
      return undefined;
    }
    if (!active) {
      setShown(0);
      return undefined;
    }

    let frame = 0;
    const started = performance.now();
    const duration = 900;
    const tick = (now) => {
      const t = Math.min(1, (now - started) / duration);
      const eased = 1 - ((1 - t) ** 3);
      if (t >= 1) {
        setShown(value);
        return;
      }
      setShown(value * eased);
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [active, reduced, runKey, value]);

  return <>{formatRegistrarNumber(shown, { precision, signed })}</>;
}
